import {LOADING_STARTS, LOADING_STOPS} from "../../../services/types/LoadingTypes";

const initialState = {

    load: false

};

export const SignUpReducer = (state=initialState, action) => {

    const {payload, type} = action;
    switch (type) {
        case LOADING_STARTS:
            return {

                ...state,
                load: payload

            };

        case LOADING_STOPS:
            return {

                ...state,
                load: payload

            };


        default:
            return state;

    }

};

export default SignUpReducer;